// API Configuration
// این فایل تعیین می‌کند که از Mock Data استفاده شود یا Real API

export const API_CONFIG = {
  // حالت: 'mock' برای Mock Data، 'real' برای Real API
  mode: (import.meta.env.VITE_API_MODE || 'mock') as 'mock' | 'real',

  // Base URL برای Real API
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',

  // WebSocket URL
  wsURL: import.meta.env.VITE_WS_URL || 'http://localhost:3003',

  // Timeout برای درخواست‌ها
  timeout: Number(import.meta.env.VITE_API_TIMEOUT || 10000),
};

// Helper function برای چک کردن اینکه آیا Mock Mode فعال است یا نه
export const isMockMode = () => API_CONFIG.mode === 'mock';

// Helper function برای چک کردن اینکه آیا Real API Mode فعال است یا نه
export const isRealApiMode = () => API_CONFIG.mode === 'real';

if (import.meta.env.DEV) {
  console.info(`[API] mode=${API_CONFIG.mode}, baseURL=${API_CONFIG.baseURL}`);
}

